var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_error_48px copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-17.000000, -336.000000)",
    fill: "#0091EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "station-note",
    transform: "translate(17.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_error_48px-copy",
    transform: "translate(8.000000, 10.000000) scale(1, -1) translate(-8.000000, -10.000000) translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.584,0 0,3.58 0,8 C0,12.42 3.584,16 8,16 C12.416,16 16,12.42 16,8 C16,3.58 12.416,0 8,0 Z M8.8,12 L7.2,12 L7.2,10.4 L8.8,10.4 L8.8,12 Z M8.8,8.8 L7.2,8.8 L7.2,4 L8.8,4 L8.8,8.8 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationNote);
export default __webpack_public_path__ + "static/media/stationNote.4c3e7fbae2025cfd29324430e6b62ffc.svg";
export { ForwardRef as ReactComponent };